
<template>
  <div id="app">

    <!-- 🔥 1. VIDEO -->
    <template v-if="pantalla === 'inicio'">
      <InicioLogo 
        v-if="isSmallScreen"
        @termino-video="irAPreguntar"
      />
      <PantallaG v-else />
    </template>

    <!-- 🔥 2. PREGUNTAR (SIN ROUTER) -->
    <template v-else-if="pantalla === 'preguntar'">
      <Preguntar @idioma-seleccionado="establecerIdioma" />
    </template>

    <!-- 🔥 3. CONTENIDO -->
    <template v-else-if="pantalla === 'contenido'">

      <!-- ESPAÑOL -->
      <template v-if="idiomaSeleccionado === 'es'">
        <Componentep 
          v-if="isSmallScreen"
          :id-invitado="idInvitado"
        />
        <PantallaG v-else />
      </template>

      <!-- INGLÉS -->
      <template v-else-if="idiomaSeleccionado === 'en'">
        <ComponentePingles 
          v-if="isSmallScreen"
          :id-invitado="idInvitado"
        />
        <PantallaG v-else />
      </template>

    </template>

  </div>
</template>

<script>
import { ref, watch, onMounted, onBeforeUnmount } from 'vue'
import { useRoute } from 'vue-router'

import InicioLogo from './components/inicio.vue'
import Preguntar from './components/preguntar.vue'
import Componentep from './components/contenedor.vue'
import ComponentePingles from './components/ingles/contenedor_ingles.vue'
import PantallaG from './components/pantallas_g.vue'

export default {
  components: {
    InicioLogo,
    Preguntar,
    Componentep,
    ComponentePingles,
    PantallaG,
  },

  setup() {
    const route = useRoute()

    const idInvitado = ref(Number(route.params.idInvitado) || undefined)
    const isSmallScreen = ref(window.innerWidth < 768)

    // 🔥 ENTRAR DIRECTAMENTE A CONTENEDOR.VUE
    const pantalla = ref('contenido')
    const idiomaSeleccionado = ref('es')

    const irAPreguntar = () => {
      pantalla.value = 'preguntar'
    }

    const establecerIdioma = (idioma) => {
      idiomaSeleccionado.value = idioma
      pantalla.value = 'contenido'
    }

    const actualizarPantalla = () => {
      isSmallScreen.value = window.innerWidth < 768
    }

    watch(() => route.params.idInvitado, (newId) => {
      idInvitado.value = Number(newId) || undefined
    })

    onMounted(() => {
      window.addEventListener('resize', actualizarPantalla)
    })

    onBeforeUnmount(() => {
      window.removeEventListener('resize', actualizarPantalla)
    })

    return {
      idInvitado,
      isSmallScreen,
      pantalla,
      idiomaSeleccionado,
      irAPreguntar,
      establecerIdioma,
    }
  }
}
</script>
